<script lang="ts">
  import TabCatsUniverse from '$lib/components/menu/TabCatsUniverse.svelte';
	import TabUniverses from '$lib/components/menu/TabUniverses.svelte';
	import TabUs from '$lib/components/menu/TabUs.svelte';
  import Logo from '$lib/components/partials/Logo.svelte'
	import { getUniverseInfo } from '$lib/js/helpers'
  import { storeHeroMenu } from '$lib/js/stores';
	import { onMount, onDestroy } from 'svelte';
  import { page } from '$app/stores';
  import { t } from 'svelte-i18n-lingui';
  import type { Category } from "$lib/js/elasticsearch/types";
	import { getContextScope } from '$lib/js/helpers/i18n'

  export let firstLevel: Category[]
  export let secondLevel: Category[]
  export let thirdLevel: Category[]
	const scope = getContextScope()

  $: universe_info = getUniverseInfo(
    $page.data?.universes_menu?.universes,
    $page.data?.category?.url_path?.split("/")[1]
  )

  $: selectedTab = universe_info ? "cats" : "universes"

  const tabs = [
    {
      icon: "categories",
      id: "cats",
      name: $t`Categories`,
    },
    {
      icon: "shop",
      id: "universes",
      name: $t`Shops`,
    },
    {
      icon: "help",
      id: "us",
      name: $t`Contact`,
    }
  ]

  // Handle back actions using popstate
	function handlePopState() {
		$storeHeroMenu = ''
	}

	// Set up event listener on mount and remove on destroy
	onMount(() => {
		// Add a state entry to allow back actions to be detected
		history.pushState(null, '', window.location.href)

		if (typeof window != 'undefined') {
			window.addEventListener('popstate', handlePopState)
		}
	})

	onDestroy(() => {
		if (typeof window != 'undefined') {
			window.removeEventListener('popstate', handlePopState)
		}

    $storeHeroMenu = ''
	})
</script>


<div class="hero-mobile">
  <div class="hero-mobile__inner">
    <button class="icon icon-cross" on:click={() => $storeHeroMenu = ''}></button>

    <div class="hero-mobile__header">
      <div class="hero-mobile__top">
        <a class="logo" href="/{scope}" aria-label="{$t`Home`}" on:click={() => $storeHeroMenu = ''}><Logo/></a>
      </div>

      <div class="hero-mobile__tabs">
        {#each tabs as tab}
          {#if universe_info || (!universe_info && tab.id !== "cats")}
            <button
              class="hero-mobile__tab"
              class:selected={selectedTab === tab.id}
              on:click={() => selectedTab = tab.id}
            >
              <span class="icon icon-{tab.icon}"></span>
              <span class="text">{tab.name}</span>
            </button>
          {/if}
        {/each}
      </div>
    </div>

    <div class="hero-mobile__content">
      {#if selectedTab === "cats"}
        <TabCatsUniverse {firstLevel} {secondLevel} {thirdLevel} />
      {:else if selectedTab === "universes"}
        <TabUniverses />
      {:else if selectedTab === "us"}
        <TabUs />
      {/if}
    </div>
  </div>
</div>


<style lang="scss">
  .hero-mobile {
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;

    &__inner {
      max-width: 400px;
      background: white;
      position: relative;
    }

    .icon-cross {
      padding: 10px;
      position: absolute;
      right: 10px;
      top: 4px;
      transition: none;
      font-size: 16px;
    }

    &__header {
      background: white;
      box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.12);
    }

    &__top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-right: 65px;

      a.logo {
        padding: 20px 20px 0;
        display: flex;
        margin-bottom: 15px;
      }
    }

    &__tabs {
      display: flex;
      justify-content: space-between;
    }

    &__tab {
      width: 50%;
      text-align: center;
      padding: 10px 0;
      background: var(--grey);

      &.selected {
        background: white;
      }

      span.icon {
        margin-right: 6px;
      }
    }

    &__content {
      min-height: calc(100dvh - 96px);
    }
  }
</style>
